/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * DasAR Admin API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

/**
 * @nullable
 */
export type SuccessType = {
  success: boolean;
  message: string;
} | null;

export type ErrorsTypeItem = {
  /** @nullable */
  field: string | null;
  detail: string;
};

/**
 * @nullable
 */
export type ErrorsType = ErrorsTypeItem[] | null;

export type InvitationTypeState = typeof InvitationTypeState[keyof typeof InvitationTypeState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitationTypeState = {
  pending: 'pending',
  viewed: 'viewed',
  accepted: 'accepted',
  revoked: 'revoked',
} as const;

/**
 * @nullable
 */
export type InvitationTypeMetadata = {
  projectUids?: string[];
} | null;

export interface InvitationType {
  /** @nullable */
  type: string | null;
  uid: string;
  email: string;
  state: InvitationTypeState;
  role: string;
  /** @nullable */
  acceptedAt: string | null;
  /** @nullable */
  resentAt: string | null;
  /** @nullable */
  expiresAt: string | null;
  createdAt: string;
  /** @nullable */
  metadata: InvitationTypeMetadata;
}

export type InvoiceTypeState = typeof InvoiceTypeState[keyof typeof InvoiceTypeState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceTypeState = {
  pending: 'pending',
  paid: 'paid',
} as const;

export type InvoiceTypeMetadataPaymentCard = {
  brand?: string;
  ending?: string;
  expMonth?: number;
  expYear?: number;
};

export type InvoiceTypeMetadataSubscription = {
  name?: string;
  start?: string;
  end?: string;
};

export type InvoiceTypeMetadata = {
  paymentCard?: InvoiceTypeMetadataPaymentCard;
  subscription?: InvoiceTypeMetadataSubscription;
};

export interface InvoiceType {
  /** @nullable */
  type: string | null;
  uid: string;
  code: string;
  state: InvoiceTypeState;
  currency: string;
  priceCents: number;
  invoiceUrl: string;
  invoicePdf: string;
  createdAt: string;
  metadata: InvoiceTypeMetadata;
}

export interface MeType {
  /** @nullable */
  type: string | null;
  uid: string;
  email: string;
  firstName: string;
  lastName: string;
  name: string;
  handle: string;
  /** @nullable */
  imageUrl: string | null;
  /** @nullable */
  lastActiveAt: string | null;
  emailVerified: boolean;
  /** @nullable */
  plan: PlanType;
  /** @nullable */
  paymentCard: PaymentCardType;
}

export type MeshTypeFileFormat = typeof MeshTypeFileFormat[keyof typeof MeshTypeFileFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeshTypeFileFormat = {
  glb: 'glb',
  gltf: 'gltf',
  usdz: 'usdz',
} as const;

export interface MeshType {
  /** @nullable */
  type: string | null;
  uid: string;
  name: string;
  fileFormat: MeshTypeFileFormat;
  /** @nullable */
  fileUrl: string | null;
  /** @nullable */
  fileUsdzUrl: string | null;
  /** @nullable */
  imageUrl: string | null;
  byteSize?: number;
  /** @nullable */
  assigned?: boolean | null;
  projectsCount?: number;
  viewCount?: number;
  createdAt?: string;
  /** @nullable */
  owner?: UserType;
  /** @nullable */
  uploader?: UserType;
}

export interface OrganizationType {
  /** @nullable */
  type: string | null;
  uid: string;
  name: string;
  slug: string;
}

/**
 * @nullable
 */
export type PaymentCardTypeBillingAddress = {
  name: string;
  line1?: string;
  /** @nullable */
  line2?: string | null;
  postalCode?: number;
  state?: string;
  city?: string;
  country: string;
} | null;

export interface PaymentCardType {
  /** @nullable */
  type: string | null;
  uid: string;
  country: string;
  brand: string;
  ending: string;
  expMonth: number;
  expYear: number;
  /** @nullable */
  billingAddress: PaymentCardTypeBillingAddress;
  /** @nullable */
  default: boolean | null;
}

export type PlanTypeBillingInterval = typeof PlanTypeBillingInterval[keyof typeof PlanTypeBillingInterval];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanTypeBillingInterval = {
  month: 'month',
  year: 'year',
} as const;

export type PlanTypeBilling = {
  symbol: string;
  currency: string;
  priceCents: number;
  interval: PlanTypeBillingInterval;
  intervalCount: number;
  custom: boolean;
};

export interface PlanType {
  /** @nullable */
  type: string | null;
  uid: string;
  name: string;
  /** @nullable */
  description: string | null;
  variantOf: string;
  sequence: number;
  billing: PlanTypeBilling;
  features: PlanFeaturesType;
  featuresOverride: PlanFeaturesType;
}

export interface ProjectType {
  /** @nullable */
  type: string | null;
  uid: string;
  name: string;
  slug: string;
  previewState?: ProjectStateType;
  liveState?: ProjectStateType;
  /** @nullable */
  creatorName?: string | null;
  /** @nullable */
  creatorHandle?: string | null;
  recordAnalytics?: boolean;
  membersCount?: number;
  meshesCount?: number;
  /** @nullable */
  isSaved?: boolean | null;
  /** @nullable */
  isPublished?: boolean | null;
  /** @nullable */
  organizationName?: string | null;
  updatedAt?: string;
  /** @nullable */
  isMine?: boolean | null;
  /** @nullable */
  byteSizeLimit?: number | null;
  meshes?: MeshType[];
  users?: UserType[];
}

export interface ResourceType {
  /** @nullable */
  type: string | null;
  uid: string;
  name: string;
  /** @nullable */
  fileFormat: string | null;
  /** @nullable */
  fileUrl: string | null;
  byteSize?: number;
  projectsCount?: number;
  createdAt?: string;
  /** @nullable */
  owner?: UserType;
  /** @nullable */
  uploader?: UserType;
}

export interface SessionType {
  /** @nullable */
  type: string | null;
  uid: string;
  /** @nullable */
  ip: string | null;
  /** @nullable */
  userAgent: string | null;
  /** @nullable */
  expiresAt: string | null;
  createdAt: string;
}

export interface UserType {
  /** @nullable */
  type: string | null;
  uid: string;
  email: string;
  name: string;
  handle: string;
  /** @nullable */
  imageUrl: string | null;
  /** @nullable */
  lastActiveAt: string | null;
  /** @nullable */
  collabProjectsCount?: number | null;
  /** @nullable */
  projectRole?: string | null;
}

export type PlanFeaturesTypeItemValue = number | boolean;

/**
 * @nullable
 */
export type PlanFeaturesTypeItem = {
  id: string;
  name: string;
  desc: string;
  valueReadable?: string;
  value: PlanFeaturesTypeItemValue;
} | null;

export type PlanFeaturesType = PlanFeaturesTypeItem[];

/**
 * @nullable
 */
export type ProjectStateType = {
  version: number;
  published: boolean;
  publishedAt: string;
  /** @nullable */
  publishedBy: string | null;
  token: string;
  /** @nullable */
  contentToken: string | null;
  meshesUids: string[];
} | null;

export type GetCollabsParams = {
organization_uid?: string;
};

export type GetCollabs200 = {
  data: UserType[];
  errors: ErrorsType;
};

export type RemoveCollabsBody = {
  uids: string[];
};

export type RemoveCollabs200 = {
  data: SuccessType;
  errors: ErrorsType;
};

export type GetInvitations200 = {
  data: InvitationType[];
  errors: ErrorsType;
};

export type CreateInvitationBody = {
  emails: string;
  projectUids: string[];
};

export type CreateInvitation200 = {
  data: SuccessType;
  errors: ErrorsType;
};

/**
 * @nullable
 */
export type CreateInvitation422Data = unknown | null;

export type CreateInvitation422 = {
  /** @nullable */
  data: CreateInvitation422Data;
  errors: ErrorsType;
};

export type AcceptInviteParams = {
token: string;
};

export type AcceptInvite200 = {
  data: SuccessType;
  errors: ErrorsType;
};

export type ResendInvitation200 = {
  data: InvitationType;
  errors: ErrorsType;
};

/**
 * @nullable
 */
export type ResendInvitation403Data = unknown | null;

export type ResendInvitation403 = {
  /** @nullable */
  data: ResendInvitation403Data;
  errors: ErrorsType;
};

export type RevokeInvitation200 = {
  data: InvitationType;
  errors: ErrorsType;
};

export type GetInvoices200 = {
  data: InvoiceType[];
  errors: ErrorsType;
};

export type GetMe200 = {
  data: MeType;
  errors: ErrorsType;
};

export type UpdateMeBody = {
  handle?: string;
  firstName?: string;
  lastName?: string;
};

export type UpdateMe200 = {
  data: MeType;
  errors: ErrorsType;
};

export type DeleteMe200 = {
  data: MeType;
  errors: ErrorsType;
};

export type RequestResetPasswordBody = {
  email: string;
};

export type RequestResetPassword200 = {
  data: SuccessType;
  errors: ErrorsType;
};

export type ResetPasswordBody = {
  token: string;
  password: string;
};

export type ResetPassword200Data = {
  jwt: string;
  me: MeType;
};

export type ResetPassword200 = {
  data: ResetPassword200Data;
  errors: ErrorsType;
};

export type GetMeshesParams = {
filter: GetMeshesFilter;
};

export type GetMeshesFilter = typeof GetMeshesFilter[keyof typeof GetMeshesFilter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMeshesFilter = {
  mine: 'mine',
  collab: 'collab',
} as const;

export type GetMeshes200 = {
  data: MeshType[];
  errors: ErrorsType;
};

export type CreateMeshBody = {
  file: Blob;
  projectUid?: string;
};

export type CreateMesh201 = {
  data: MeshType;
  errors: ErrorsType;
};

/**
 * @nullable
 */
export type CreateMesh403Data = unknown | null;

export type CreateMesh403 = {
  /** @nullable */
  data: CreateMesh403Data;
  errors: ErrorsType;
};

export type UpdateMeshBody = {
  name?: string;
  image?: Blob;
};

export type UpdateMesh200 = {
  data: MeshType;
  errors: ErrorsType;
};

export type AddMeshesToProjectBody = {
  projectUid: string;
  uids: string[];
};

export type AddMeshesToProject200 = {
  data: SuccessType;
  errors: ErrorsType;
};

export type DeleteMeshesBody = {
  uids: string[];
};

export type DeleteMeshes200 = {
  data: SuccessType;
  errors: ErrorsType;
};

export type GetOrganizations200 = {
  data: OrganizationType[];
  errors: ErrorsType;
};

export type GetPaymentCards200 = {
  data: PaymentCardType[];
  errors: ErrorsType;
};

export type CreatePaymentCard201 = {
  data: SuccessType;
  errors: ErrorsType;
};

export type UpdatePaymentCardBody = {
  name?: string;
  line1?: string;
  line2?: string;
  postal_code?: number;
  state?: string;
  city?: string;
  country?: string;
};

export type UpdatePaymentCard200 = {
  data: PaymentCardType;
  errors: ErrorsType;
};

export type DeletePaymentCard200 = {
  data: PaymentCardType;
  errors: ErrorsType;
};

export type SetDefaultPaymentCard200 = {
  data: PaymentCardType;
  errors: ErrorsType;
};

export type GetPlans200 = {
  data: PlanType[];
  errors: ErrorsType;
};

export type GetPlan200 = {
  data: PlanType;
  errors: ErrorsType;
};

export type GetProjectsParams = {
filter: GetProjectsFilter;
};

export type GetProjectsFilter = typeof GetProjectsFilter[keyof typeof GetProjectsFilter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsFilter = {
  all: 'all',
  mine: 'mine',
  collab: 'collab',
} as const;

export type GetProjects200 = {
  data: ProjectType[];
  errors: ErrorsType;
};

export type CreateProjectBody = {
  name: string;
  slug: string;
};

export type CreateProject201 = {
  data: ProjectType;
  errors: ErrorsType;
};

/**
 * @nullable
 */
export type CreateProject403Data = unknown | null;

export type CreateProject403 = {
  /** @nullable */
  data: CreateProject403Data;
  errors: ErrorsType;
};

export type GetProject200 = {
  data: ProjectType;
  errors: ErrorsType;
};

export type UpdateProjectBody = {
  name?: string;
  slug?: string;
  record_analytics?: boolean;
};

export type UpdateProject200 = {
  data: ProjectType;
  errors: ErrorsType;
};

export type SaveProjectStateBody = {
  published?: boolean;
  contentToken?: string;
  resourceUids?: string[];
  meshesUids?: string[];
};

export type SaveProjectState200 = {
  data: ProjectType;
  errors: ErrorsType;
};

/**
 * @nullable
 */
export type SaveProjectState422Data = unknown | null;

export type SaveProjectState422 = {
  /** @nullable */
  data: SaveProjectState422Data;
  errors: ErrorsType;
};

export type PublishProject200 = {
  data: ProjectType;
  errors: ErrorsType;
};

export type DeleteProjectsBody = {
  uids: string[];
};

export type DeleteProjects200 = {
  data: SuccessType;
  errors: ErrorsType;
};

export type GetResourcesParams = {
filter: GetResourcesFilter;
};

export type GetResourcesFilter = typeof GetResourcesFilter[keyof typeof GetResourcesFilter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetResourcesFilter = {
  mine: 'mine',
  collab: 'collab',
} as const;

export type GetResources200 = {
  data: ResourceType[];
  errors: ErrorsType;
};

export type CreateResourceBody = {
  file: Blob;
  projectUid?: string;
};

export type CreateResource201 = {
  data: ResourceType;
  errors: ErrorsType;
};

/**
 * @nullable
 */
export type CreateResource403Data = unknown | null;

export type CreateResource403 = {
  /** @nullable */
  data: CreateResource403Data;
  errors: ErrorsType;
};

export type DeleteResourcesBody = {
  uids: string[];
};

export type DeleteResources200 = {
  data: SuccessType;
  errors: ErrorsType;
};

export type SignInBody = {
  email: string;
  password: string;
};

export type SignIn201Data = {
  jwt: string;
  me: UserType;
};

export type SignIn201 = {
  data: SignIn201Data;
  errors: ErrorsType;
};

/**
 * @nullable
 */
export type SignIn422Data = unknown | null;

export type SignIn422 = {
  /** @nullable */
  data: SignIn422Data;
  errors: ErrorsType;
};

export type SignOut200 = {
  data: SuccessType;
  errors: ErrorsType;
};

export type CreateSubscriptionUrlBody = {
  planUid: string;
};

export type CreateSubscriptionUrl201 = {
  data: SuccessType;
  errors: ErrorsType;
};

export type SignUpBody = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
};

export type SignUp201Data = {
  jwt: string;
  me: MeType;
};

export type SignUp201 = {
  data: SignUp201Data;
  errors: ErrorsType;
};

/**
 * @summary Get collabs
 */
export const getCollabs = (
    params?: GetCollabsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCollabs200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/collabs`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetCollabsQueryKey = (params?: GetCollabsParams,) => {
    return [`/api/v1/admin/collabs`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCollabsQueryOptions = <TData = Awaited<ReturnType<typeof getCollabs>>, TError = AxiosError<unknown>>(params?: GetCollabsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollabs>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollabsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollabs>>> = ({ signal }) => getCollabs(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCollabs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCollabsQueryResult = NonNullable<Awaited<ReturnType<typeof getCollabs>>>
export type GetCollabsQueryError = AxiosError<unknown>


export function useGetCollabs<TData = Awaited<ReturnType<typeof getCollabs>>, TError = AxiosError<unknown>>(
 params: undefined |  GetCollabsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollabs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollabs>>,
          TError,
          Awaited<ReturnType<typeof getCollabs>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollabs<TData = Awaited<ReturnType<typeof getCollabs>>, TError = AxiosError<unknown>>(
 params?: GetCollabsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollabs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollabs>>,
          TError,
          Awaited<ReturnType<typeof getCollabs>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollabs<TData = Awaited<ReturnType<typeof getCollabs>>, TError = AxiosError<unknown>>(
 params?: GetCollabsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollabs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get collabs
 */

export function useGetCollabs<TData = Awaited<ReturnType<typeof getCollabs>>, TError = AxiosError<unknown>>(
 params?: GetCollabsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollabs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCollabsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Remove collabs
 */
export const removeCollabs = (
    removeCollabsBody: RemoveCollabsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RemoveCollabs200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/collabs/bulk_destroy`,
      removeCollabsBody,options
    );
  }



export const getRemoveCollabsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCollabs>>, TError,{data: RemoveCollabsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeCollabs>>, TError,{data: RemoveCollabsBody}, TContext> => {

const mutationKey = ['removeCollabs'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCollabs>>, {data: RemoveCollabsBody}> = (props) => {
          const {data} = props ?? {};

          return  removeCollabs(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveCollabsMutationResult = NonNullable<Awaited<ReturnType<typeof removeCollabs>>>
    export type RemoveCollabsMutationBody = RemoveCollabsBody
    export type RemoveCollabsMutationError = AxiosError<unknown>

    /**
 * @summary Remove collabs
 */
export const useRemoveCollabs = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCollabs>>, TError,{data: RemoveCollabsBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCollabs>>,
        TError,
        {data: RemoveCollabsBody},
        TContext
      > => {

      const mutationOptions = getRemoveCollabsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get invitations
 */
export const getInvitations = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetInvitations200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/invitations`,options
    );
  }


export const getGetInvitationsQueryKey = () => {
    return [`/api/v1/admin/invitations`] as const;
    }

    
export const getGetInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof getInvitations>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitations>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitations>>> = ({ signal }) => getInvitations({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitations>>>
export type GetInvitationsQueryError = AxiosError<unknown>


export function useGetInvitations<TData = Awaited<ReturnType<typeof getInvitations>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitations>>,
          TError,
          Awaited<ReturnType<typeof getInvitations>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitations<TData = Awaited<ReturnType<typeof getInvitations>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitations>>,
          TError,
          Awaited<ReturnType<typeof getInvitations>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitations<TData = Awaited<ReturnType<typeof getInvitations>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitations>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get invitations
 */

export function useGetInvitations<TData = Awaited<ReturnType<typeof getInvitations>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitations>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create invitation
 */
export const createInvitation = (
    createInvitationBody: CreateInvitationBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateInvitation200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/invitations`,
      createInvitationBody,options
    );
  }



export const getCreateInvitationMutationOptions = <TError = AxiosError<CreateInvitation422>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{data: CreateInvitationBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{data: CreateInvitationBody}, TContext> => {

const mutationKey = ['createInvitation'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvitation>>, {data: CreateInvitationBody}> = (props) => {
          const {data} = props ?? {};

          return  createInvitation(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof createInvitation>>>
    export type CreateInvitationMutationBody = CreateInvitationBody
    export type CreateInvitationMutationError = AxiosError<CreateInvitation422>

    /**
 * @summary Create invitation
 */
export const useCreateInvitation = <TError = AxiosError<CreateInvitation422>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{data: CreateInvitationBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInvitation>>,
        TError,
        {data: CreateInvitationBody},
        TContext
      > => {

      const mutationOptions = getCreateInvitationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Accept invitation
 */
export const acceptInvite = (
    params: AcceptInviteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AcceptInvite200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/invitations/accept`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getAcceptInviteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{params: AcceptInviteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{params: AcceptInviteParams}, TContext> => {

const mutationKey = ['acceptInvite'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvite>>, {params: AcceptInviteParams}> = (props) => {
          const {params} = props ?? {};

          return  acceptInvite(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptInviteMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvite>>>
    
    export type AcceptInviteMutationError = AxiosError<unknown>

    /**
 * @summary Accept invitation
 */
export const useAcceptInvite = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{params: AcceptInviteParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvite>>,
        TError,
        {params: AcceptInviteParams},
        TContext
      > => {

      const mutationOptions = getAcceptInviteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Resend invitation
 */
export const resendInvitation = (
    invitationUid: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ResendInvitation200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/invitations/${invitationUid}/resend`,undefined,options
    );
  }



export const getResendInvitationMutationOptions = <TError = AxiosError<ResendInvitation403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{invitationUid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{invitationUid: string}, TContext> => {

const mutationKey = ['resendInvitation'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInvitation>>, {invitationUid: string}> = (props) => {
          const {invitationUid} = props ?? {};

          return  resendInvitation(invitationUid,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof resendInvitation>>>
    
    export type ResendInvitationMutationError = AxiosError<ResendInvitation403>

    /**
 * @summary Resend invitation
 */
export const useResendInvitation = <TError = AxiosError<ResendInvitation403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{invitationUid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendInvitation>>,
        TError,
        {invitationUid: string},
        TContext
      > => {

      const mutationOptions = getResendInvitationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Revoke invitation
 */
export const revokeInvitation = (
    uid: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RevokeInvitation200>> => {
    
    
    return axios.default.delete(
      `/api/v1/admin/invitations/${uid}`,options
    );
  }



export const getRevokeInvitationMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,{uid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,{uid: string}, TContext> => {

const mutationKey = ['revokeInvitation'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeInvitation>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  revokeInvitation(uid,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof revokeInvitation>>>
    
    export type RevokeInvitationMutationError = AxiosError<unknown>

    /**
 * @summary Revoke invitation
 */
export const useRevokeInvitation = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,{uid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeInvitation>>,
        TError,
        {uid: string},
        TContext
      > => {

      const mutationOptions = getRevokeInvitationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get invoices
 */
export const getInvoices = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetInvoices200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/invoices`,options
    );
  }


export const getGetInvoicesQueryKey = () => {
    return [`/api/v1/admin/invoices`] as const;
    }

    
export const getGetInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getInvoices>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoices>>> = ({ signal }) => getInvoices({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoices>>>
export type GetInvoicesQueryError = AxiosError<unknown>


export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get invoices
 */

export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get profile
 */
export const getMe = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetMe200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/me`,options
    );
  }


export const getGetMeQueryKey = () => {
    return [`/api/v1/admin/me`] as const;
    }

    
export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = AxiosError<unknown>


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get profile
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update profile
 */
export const updateMe = (
    updateMeBody: UpdateMeBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateMe200>> => {
    
    
    return axios.default.put(
      `/api/v1/admin/me`,
      updateMeBody,options
    );
  }



export const getUpdateMeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: UpdateMeBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: UpdateMeBody}, TContext> => {

const mutationKey = ['updateMe'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMe>>, {data: UpdateMeBody}> = (props) => {
          const {data} = props ?? {};

          return  updateMe(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMeMutationResult = NonNullable<Awaited<ReturnType<typeof updateMe>>>
    export type UpdateMeMutationBody = UpdateMeBody
    export type UpdateMeMutationError = AxiosError<unknown>

    /**
 * @summary Update profile
 */
export const useUpdateMe = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: UpdateMeBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMe>>,
        TError,
        {data: UpdateMeBody},
        TContext
      > => {

      const mutationOptions = getUpdateMeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Delete account
 */
export const deleteMe = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteMe200>> => {
    
    
    return axios.default.delete(
      `/api/v1/admin/me`,options
    );
  }



export const getDeleteMeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMe>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMe>>, TError,void, TContext> => {

const mutationKey = ['deleteMe'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMe>>, void> = () => {
          

          return  deleteMe(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMe>>>
    
    export type DeleteMeMutationError = AxiosError<unknown>

    /**
 * @summary Delete account
 */
export const useDeleteMe = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMe>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMe>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteMeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Reset password request
 */
export const requestResetPassword = (
    requestResetPasswordBody: RequestResetPasswordBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RequestResetPassword200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/me/reset_password_request`,
      requestResetPasswordBody,options
    );
  }



export const getRequestResetPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestResetPassword>>, TError,{data: RequestResetPasswordBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestResetPassword>>, TError,{data: RequestResetPasswordBody}, TContext> => {

const mutationKey = ['requestResetPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestResetPassword>>, {data: RequestResetPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  requestResetPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof requestResetPassword>>>
    export type RequestResetPasswordMutationBody = RequestResetPasswordBody
    export type RequestResetPasswordMutationError = AxiosError<unknown>

    /**
 * @summary Reset password request
 */
export const useRequestResetPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestResetPassword>>, TError,{data: RequestResetPasswordBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestResetPassword>>,
        TError,
        {data: RequestResetPasswordBody},
        TContext
      > => {

      const mutationOptions = getRequestResetPasswordMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Reset password
 */
export const resetPassword = (
    resetPasswordBody: ResetPasswordBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ResetPassword200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/me/reset_password`,
      resetPasswordBody,options
    );
  }



export const getResetPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordBody
    export type ResetPasswordMutationError = AxiosError<unknown>

    /**
 * @summary Reset password
 */
export const useResetPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordBody},
        TContext
      > => {

      const mutationOptions = getResetPasswordMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get meshes
 */
export const getMeshes = (
    params: GetMeshesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetMeshes200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/meshes`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetMeshesQueryKey = (params: GetMeshesParams,) => {
    return [`/api/v1/admin/meshes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMeshesQueryOptions = <TData = Awaited<ReturnType<typeof getMeshes>>, TError = AxiosError<unknown>>(params: GetMeshesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeshesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeshes>>> = ({ signal }) => getMeshes(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeshesQueryResult = NonNullable<Awaited<ReturnType<typeof getMeshes>>>
export type GetMeshesQueryError = AxiosError<unknown>


export function useGetMeshes<TData = Awaited<ReturnType<typeof getMeshes>>, TError = AxiosError<unknown>>(
 params: GetMeshesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeshes>>,
          TError,
          Awaited<ReturnType<typeof getMeshes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeshes<TData = Awaited<ReturnType<typeof getMeshes>>, TError = AxiosError<unknown>>(
 params: GetMeshesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeshes>>,
          TError,
          Awaited<ReturnType<typeof getMeshes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeshes<TData = Awaited<ReturnType<typeof getMeshes>>, TError = AxiosError<unknown>>(
 params: GetMeshesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get meshes
 */

export function useGetMeshes<TData = Awaited<ReturnType<typeof getMeshes>>, TError = AxiosError<unknown>>(
 params: GetMeshesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeshesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create mesh
 */
export const createMesh = (
    createMeshBody: CreateMeshBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateMesh201>> => {
    
    const formData = new FormData();
formData.append(`file`, createMeshBody.file)
if(createMeshBody.projectUid !== undefined) {
 formData.append(`projectUid`, createMeshBody.projectUid)
 }

    return axios.default.post(
      `/api/v1/admin/meshes`,
      formData,options
    );
  }



export const getCreateMeshMutationOptions = <TError = AxiosError<CreateMesh403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMesh>>, TError,{data: CreateMeshBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createMesh>>, TError,{data: CreateMeshBody}, TContext> => {

const mutationKey = ['createMesh'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMesh>>, {data: CreateMeshBody}> = (props) => {
          const {data} = props ?? {};

          return  createMesh(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMeshMutationResult = NonNullable<Awaited<ReturnType<typeof createMesh>>>
    export type CreateMeshMutationBody = CreateMeshBody
    export type CreateMeshMutationError = AxiosError<CreateMesh403>

    /**
 * @summary Create mesh
 */
export const useCreateMesh = <TError = AxiosError<CreateMesh403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMesh>>, TError,{data: CreateMeshBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMesh>>,
        TError,
        {data: CreateMeshBody},
        TContext
      > => {

      const mutationOptions = getCreateMeshMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Update mesh
 */
export const updateMesh = (
    uid: string,
    updateMeshBody: UpdateMeshBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateMesh200>> => {
    
    const formData = new FormData();
if(updateMeshBody.name !== undefined) {
 formData.append(`name`, updateMeshBody.name)
 }
if(updateMeshBody.image !== undefined) {
 formData.append(`image`, updateMeshBody.image)
 }

    return axios.default.put(
      `/api/v1/admin/meshes/${uid}`,
      formData,options
    );
  }



export const getUpdateMeshMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMesh>>, TError,{uid: string;data: UpdateMeshBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateMesh>>, TError,{uid: string;data: UpdateMeshBody}, TContext> => {

const mutationKey = ['updateMesh'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMesh>>, {uid: string;data: UpdateMeshBody}> = (props) => {
          const {uid,data} = props ?? {};

          return  updateMesh(uid,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMeshMutationResult = NonNullable<Awaited<ReturnType<typeof updateMesh>>>
    export type UpdateMeshMutationBody = UpdateMeshBody
    export type UpdateMeshMutationError = AxiosError<unknown>

    /**
 * @summary Update mesh
 */
export const useUpdateMesh = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMesh>>, TError,{uid: string;data: UpdateMeshBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMesh>>,
        TError,
        {uid: string;data: UpdateMeshBody},
        TContext
      > => {

      const mutationOptions = getUpdateMeshMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Add meshes to project
 */
export const addMeshesToProject = (
    addMeshesToProjectBody: AddMeshesToProjectBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AddMeshesToProject200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/meshes/add_to_project`,
      addMeshesToProjectBody,options
    );
  }



export const getAddMeshesToProjectMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addMeshesToProject>>, TError,{data: AddMeshesToProjectBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addMeshesToProject>>, TError,{data: AddMeshesToProjectBody}, TContext> => {

const mutationKey = ['addMeshesToProject'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addMeshesToProject>>, {data: AddMeshesToProjectBody}> = (props) => {
          const {data} = props ?? {};

          return  addMeshesToProject(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddMeshesToProjectMutationResult = NonNullable<Awaited<ReturnType<typeof addMeshesToProject>>>
    export type AddMeshesToProjectMutationBody = AddMeshesToProjectBody
    export type AddMeshesToProjectMutationError = AxiosError<unknown>

    /**
 * @summary Add meshes to project
 */
export const useAddMeshesToProject = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addMeshesToProject>>, TError,{data: AddMeshesToProjectBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addMeshesToProject>>,
        TError,
        {data: AddMeshesToProjectBody},
        TContext
      > => {

      const mutationOptions = getAddMeshesToProjectMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Delete meshes
 */
export const deleteMeshes = (
    deleteMeshesBody: DeleteMeshesBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteMeshes200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/meshes/bulk_destroy`,
      deleteMeshesBody,options
    );
  }



export const getDeleteMeshesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMeshes>>, TError,{data: DeleteMeshesBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMeshes>>, TError,{data: DeleteMeshesBody}, TContext> => {

const mutationKey = ['deleteMeshes'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMeshes>>, {data: DeleteMeshesBody}> = (props) => {
          const {data} = props ?? {};

          return  deleteMeshes(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMeshesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMeshes>>>
    export type DeleteMeshesMutationBody = DeleteMeshesBody
    export type DeleteMeshesMutationError = AxiosError<unknown>

    /**
 * @summary Delete meshes
 */
export const useDeleteMeshes = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMeshes>>, TError,{data: DeleteMeshesBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMeshes>>,
        TError,
        {data: DeleteMeshesBody},
        TContext
      > => {

      const mutationOptions = getDeleteMeshesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get organizations
 */
export const getOrganizations = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetOrganizations200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/organizations`,options
    );
  }


export const getGetOrganizationsQueryKey = () => {
    return [`/api/v1/admin/organizations`] as const;
    }

    
export const getGetOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizations>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizations>>> = ({ signal }) => getOrganizations({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizations>>>
export type GetOrganizationsQueryError = AxiosError<unknown>


export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organizations
 */

export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get payment cards
 */
export const getPaymentCards = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPaymentCards200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/payment_cards`,options
    );
  }


export const getGetPaymentCardsQueryKey = () => {
    return [`/api/v1/admin/payment_cards`] as const;
    }

    
export const getGetPaymentCardsQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentCardsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentCards>>> = ({ signal }) => getPaymentCards({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentCards>>>
export type GetPaymentCardsQueryError = AxiosError<unknown>


export function useGetPaymentCards<TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentCards>>,
          TError,
          Awaited<ReturnType<typeof getPaymentCards>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentCards<TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentCards>>,
          TError,
          Awaited<ReturnType<typeof getPaymentCards>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentCards<TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment cards
 */

export function useGetPaymentCards<TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentCardsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create payment card
 */
export const createPaymentCard = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreatePaymentCard201>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/payment_cards`,undefined,options
    );
  }



export const getCreatePaymentCardMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentCard>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createPaymentCard>>, TError,void, TContext> => {

const mutationKey = ['createPaymentCard'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPaymentCard>>, void> = () => {
          

          return  createPaymentCard(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePaymentCardMutationResult = NonNullable<Awaited<ReturnType<typeof createPaymentCard>>>
    
    export type CreatePaymentCardMutationError = AxiosError<unknown>

    /**
 * @summary Create payment card
 */
export const useCreatePaymentCard = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentCard>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPaymentCard>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreatePaymentCardMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Update payment card
 */
export const updatePaymentCard = (
    uid: string,
    updatePaymentCardBody: UpdatePaymentCardBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdatePaymentCard200>> => {
    
    
    return axios.default.put(
      `/api/v1/admin/payment_cards/${uid}`,
      updatePaymentCardBody,options
    );
  }



export const getUpdatePaymentCardMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentCard>>, TError,{uid: string;data: UpdatePaymentCardBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updatePaymentCard>>, TError,{uid: string;data: UpdatePaymentCardBody}, TContext> => {

const mutationKey = ['updatePaymentCard'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePaymentCard>>, {uid: string;data: UpdatePaymentCardBody}> = (props) => {
          const {uid,data} = props ?? {};

          return  updatePaymentCard(uid,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePaymentCardMutationResult = NonNullable<Awaited<ReturnType<typeof updatePaymentCard>>>
    export type UpdatePaymentCardMutationBody = UpdatePaymentCardBody
    export type UpdatePaymentCardMutationError = AxiosError<unknown>

    /**
 * @summary Update payment card
 */
export const useUpdatePaymentCard = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentCard>>, TError,{uid: string;data: UpdatePaymentCardBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePaymentCard>>,
        TError,
        {uid: string;data: UpdatePaymentCardBody},
        TContext
      > => {

      const mutationOptions = getUpdatePaymentCardMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Delete payment card
 */
export const deletePaymentCard = (
    uid: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeletePaymentCard200>> => {
    
    
    return axios.default.delete(
      `/api/v1/admin/payment_cards/${uid}`,options
    );
  }



export const getDeletePaymentCardMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentCard>>, TError,{uid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deletePaymentCard>>, TError,{uid: string}, TContext> => {

const mutationKey = ['deletePaymentCard'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePaymentCard>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  deletePaymentCard(uid,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePaymentCardMutationResult = NonNullable<Awaited<ReturnType<typeof deletePaymentCard>>>
    
    export type DeletePaymentCardMutationError = AxiosError<unknown>

    /**
 * @summary Delete payment card
 */
export const useDeletePaymentCard = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentCard>>, TError,{uid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePaymentCard>>,
        TError,
        {uid: string},
        TContext
      > => {

      const mutationOptions = getDeletePaymentCardMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Set default payment card
 */
export const setDefaultPaymentCard = (
    paymentCardUid: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SetDefaultPaymentCard200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/payment_cards/${paymentCardUid}/set_default`,undefined,options
    );
  }



export const getSetDefaultPaymentCardMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultPaymentCard>>, TError,{paymentCardUid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultPaymentCard>>, TError,{paymentCardUid: string}, TContext> => {

const mutationKey = ['setDefaultPaymentCard'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultPaymentCard>>, {paymentCardUid: string}> = (props) => {
          const {paymentCardUid} = props ?? {};

          return  setDefaultPaymentCard(paymentCardUid,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultPaymentCardMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultPaymentCard>>>
    
    export type SetDefaultPaymentCardMutationError = AxiosError<unknown>

    /**
 * @summary Set default payment card
 */
export const useSetDefaultPaymentCard = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultPaymentCard>>, TError,{paymentCardUid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultPaymentCard>>,
        TError,
        {paymentCardUid: string},
        TContext
      > => {

      const mutationOptions = getSetDefaultPaymentCardMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get plans
 */
export const getPlans = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPlans200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/plans`,options
    );
  }


export const getGetPlansQueryKey = () => {
    return [`/api/v1/admin/plans`] as const;
    }

    
export const getGetPlansQueryOptions = <TData = Awaited<ReturnType<typeof getPlans>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlansQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlans>>> = ({ signal }) => getPlans({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getPlans>>>
export type GetPlansQueryError = AxiosError<unknown>


export function useGetPlans<TData = Awaited<ReturnType<typeof getPlans>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlans>>,
          TError,
          Awaited<ReturnType<typeof getPlans>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlans<TData = Awaited<ReturnType<typeof getPlans>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlans>>,
          TError,
          Awaited<ReturnType<typeof getPlans>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlans<TData = Awaited<ReturnType<typeof getPlans>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get plans
 */

export function useGetPlans<TData = Awaited<ReturnType<typeof getPlans>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlansQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get plan
 */
export const getPlan = (
    uid: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPlan200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/plans/${uid}`,options
    );
  }


export const getGetPlanQueryKey = (uid: string,) => {
    return [`/api/v1/admin/plans/${uid}`] as const;
    }

    
export const getGetPlanQueryOptions = <TData = Awaited<ReturnType<typeof getPlan>>, TError = AxiosError<unknown>>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanQueryKey(uid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlan>>> = ({ signal }) => getPlan(uid, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(uid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getPlan>>>
export type GetPlanQueryError = AxiosError<unknown>


export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = AxiosError<unknown>>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlan>>,
          TError,
          Awaited<ReturnType<typeof getPlan>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = AxiosError<unknown>>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlan>>,
          TError,
          Awaited<ReturnType<typeof getPlan>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = AxiosError<unknown>>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get plan
 */

export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = AxiosError<unknown>>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanQueryOptions(uid,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get projects
 */
export const getProjects = (
    params: GetProjectsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetProjects200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/projects`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetProjectsQueryKey = (params: GetProjectsParams,) => {
    return [`/api/v1/admin/projects`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getProjects>>, TError = AxiosError<unknown>>(params: GetProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjects>>> = ({ signal }) => getProjects(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjects>>>
export type GetProjectsQueryError = AxiosError<unknown>


export function useGetProjects<TData = Awaited<ReturnType<typeof getProjects>>, TError = AxiosError<unknown>>(
 params: GetProjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjects>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjects<TData = Awaited<ReturnType<typeof getProjects>>, TError = AxiosError<unknown>>(
 params: GetProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjects>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjects<TData = Awaited<ReturnType<typeof getProjects>>, TError = AxiosError<unknown>>(
 params: GetProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get projects
 */

export function useGetProjects<TData = Awaited<ReturnType<typeof getProjects>>, TError = AxiosError<unknown>>(
 params: GetProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create project
 */
export const createProject = (
    createProjectBody: CreateProjectBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateProject201>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/projects`,
      createProjectBody,options
    );
  }



export const getCreateProjectMutationOptions = <TError = AxiosError<CreateProject403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: CreateProjectBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: CreateProjectBody}, TContext> => {

const mutationKey = ['createProject'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProject>>, {data: CreateProjectBody}> = (props) => {
          const {data} = props ?? {};

          return  createProject(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>
    export type CreateProjectMutationBody = CreateProjectBody
    export type CreateProjectMutationError = AxiosError<CreateProject403>

    /**
 * @summary Create project
 */
export const useCreateProject = <TError = AxiosError<CreateProject403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: CreateProjectBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProject>>,
        TError,
        {data: CreateProjectBody},
        TContext
      > => {

      const mutationOptions = getCreateProjectMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get project
 */
export const getProject = (
    uid: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetProject200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/projects/${uid}`,options
    );
  }


export const getGetProjectQueryKey = (uid: string,) => {
    return [`/api/v1/admin/projects/${uid}`] as const;
    }

    
export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = AxiosError<unknown>>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(uid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(uid, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(uid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = AxiosError<unknown>


export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = AxiosError<unknown>>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = AxiosError<unknown>>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = AxiosError<unknown>>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project
 */

export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = AxiosError<unknown>>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectQueryOptions(uid,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update project
 */
export const updateProject = (
    uid: string,
    updateProjectBody: UpdateProjectBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateProject200>> => {
    
    
    return axios.default.put(
      `/api/v1/admin/projects/${uid}`,
      updateProjectBody,options
    );
  }



export const getUpdateProjectMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{uid: string;data: UpdateProjectBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{uid: string;data: UpdateProjectBody}, TContext> => {

const mutationKey = ['updateProject'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, {uid: string;data: UpdateProjectBody}> = (props) => {
          const {uid,data} = props ?? {};

          return  updateProject(uid,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>
    export type UpdateProjectMutationBody = UpdateProjectBody
    export type UpdateProjectMutationError = AxiosError<unknown>

    /**
 * @summary Update project
 */
export const useUpdateProject = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{uid: string;data: UpdateProjectBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProject>>,
        TError,
        {uid: string;data: UpdateProjectBody},
        TContext
      > => {

      const mutationOptions = getUpdateProjectMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Save project preview state
 */
export const saveProjectState = (
    projectUid: string,
    saveProjectStateBody: SaveProjectStateBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SaveProjectState200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/projects/${projectUid}/save_state`,
      saveProjectStateBody,options
    );
  }



export const getSaveProjectStateMutationOptions = <TError = AxiosError<SaveProjectState422>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveProjectState>>, TError,{projectUid: string;data: SaveProjectStateBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof saveProjectState>>, TError,{projectUid: string;data: SaveProjectStateBody}, TContext> => {

const mutationKey = ['saveProjectState'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveProjectState>>, {projectUid: string;data: SaveProjectStateBody}> = (props) => {
          const {projectUid,data} = props ?? {};

          return  saveProjectState(projectUid,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveProjectStateMutationResult = NonNullable<Awaited<ReturnType<typeof saveProjectState>>>
    export type SaveProjectStateMutationBody = SaveProjectStateBody
    export type SaveProjectStateMutationError = AxiosError<SaveProjectState422>

    /**
 * @summary Save project preview state
 */
export const useSaveProjectState = <TError = AxiosError<SaveProjectState422>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveProjectState>>, TError,{projectUid: string;data: SaveProjectStateBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveProjectState>>,
        TError,
        {projectUid: string;data: SaveProjectStateBody},
        TContext
      > => {

      const mutationOptions = getSaveProjectStateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Publish project
 */
export const publishProject = (
    projectUid: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PublishProject200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/projects/${projectUid}/publish`,undefined,options
    );
  }



export const getPublishProjectMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishProject>>, TError,{projectUid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof publishProject>>, TError,{projectUid: string}, TContext> => {

const mutationKey = ['publishProject'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishProject>>, {projectUid: string}> = (props) => {
          const {projectUid} = props ?? {};

          return  publishProject(projectUid,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublishProjectMutationResult = NonNullable<Awaited<ReturnType<typeof publishProject>>>
    
    export type PublishProjectMutationError = AxiosError<unknown>

    /**
 * @summary Publish project
 */
export const usePublishProject = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishProject>>, TError,{projectUid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishProject>>,
        TError,
        {projectUid: string},
        TContext
      > => {

      const mutationOptions = getPublishProjectMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Delete projects
 */
export const deleteProjects = (
    deleteProjectsBody: DeleteProjectsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteProjects200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/projects/bulk_destroy`,
      deleteProjectsBody,options
    );
  }



export const getDeleteProjectsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjects>>, TError,{data: DeleteProjectsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjects>>, TError,{data: DeleteProjectsBody}, TContext> => {

const mutationKey = ['deleteProjects'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjects>>, {data: DeleteProjectsBody}> = (props) => {
          const {data} = props ?? {};

          return  deleteProjects(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjects>>>
    export type DeleteProjectsMutationBody = DeleteProjectsBody
    export type DeleteProjectsMutationError = AxiosError<unknown>

    /**
 * @summary Delete projects
 */
export const useDeleteProjects = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjects>>, TError,{data: DeleteProjectsBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjects>>,
        TError,
        {data: DeleteProjectsBody},
        TContext
      > => {

      const mutationOptions = getDeleteProjectsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get resources
 */
export const getResources = (
    params: GetResourcesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetResources200>> => {
    
    
    return axios.default.get(
      `/api/v1/admin/resources`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetResourcesQueryKey = (params: GetResourcesParams,) => {
    return [`/api/v1/admin/resources`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResourcesQueryOptions = <TData = Awaited<ReturnType<typeof getResources>>, TError = AxiosError<unknown>>(params: GetResourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResources>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResources>>> = ({ signal }) => getResources(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getResources>>>
export type GetResourcesQueryError = AxiosError<unknown>


export function useGetResources<TData = Awaited<ReturnType<typeof getResources>>, TError = AxiosError<unknown>>(
 params: GetResourcesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResources>>,
          TError,
          Awaited<ReturnType<typeof getResources>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResources<TData = Awaited<ReturnType<typeof getResources>>, TError = AxiosError<unknown>>(
 params: GetResourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResources>>,
          TError,
          Awaited<ReturnType<typeof getResources>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResources<TData = Awaited<ReturnType<typeof getResources>>, TError = AxiosError<unknown>>(
 params: GetResourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResources>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get resources
 */

export function useGetResources<TData = Awaited<ReturnType<typeof getResources>>, TError = AxiosError<unknown>>(
 params: GetResourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResources>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourcesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create resource
 */
export const createResource = (
    createResourceBody: CreateResourceBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateResource201>> => {
    
    const formData = new FormData();
formData.append(`file`, createResourceBody.file)
if(createResourceBody.projectUid !== undefined) {
 formData.append(`projectUid`, createResourceBody.projectUid)
 }

    return axios.default.post(
      `/api/v1/admin/resources`,
      formData,options
    );
  }



export const getCreateResourceMutationOptions = <TError = AxiosError<CreateResource403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResource>>, TError,{data: CreateResourceBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createResource>>, TError,{data: CreateResourceBody}, TContext> => {

const mutationKey = ['createResource'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResource>>, {data: CreateResourceBody}> = (props) => {
          const {data} = props ?? {};

          return  createResource(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateResourceMutationResult = NonNullable<Awaited<ReturnType<typeof createResource>>>
    export type CreateResourceMutationBody = CreateResourceBody
    export type CreateResourceMutationError = AxiosError<CreateResource403>

    /**
 * @summary Create resource
 */
export const useCreateResource = <TError = AxiosError<CreateResource403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResource>>, TError,{data: CreateResourceBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createResource>>,
        TError,
        {data: CreateResourceBody},
        TContext
      > => {

      const mutationOptions = getCreateResourceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Delete resources
 */
export const deleteResources = (
    deleteResourcesBody: DeleteResourcesBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteResources200>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/resources/bulk_destroy`,
      deleteResourcesBody,options
    );
  }



export const getDeleteResourcesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResources>>, TError,{data: DeleteResourcesBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteResources>>, TError,{data: DeleteResourcesBody}, TContext> => {

const mutationKey = ['deleteResources'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteResources>>, {data: DeleteResourcesBody}> = (props) => {
          const {data} = props ?? {};

          return  deleteResources(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteResources>>>
    export type DeleteResourcesMutationBody = DeleteResourcesBody
    export type DeleteResourcesMutationError = AxiosError<unknown>

    /**
 * @summary Delete resources
 */
export const useDeleteResources = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResources>>, TError,{data: DeleteResourcesBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteResources>>,
        TError,
        {data: DeleteResourcesBody},
        TContext
      > => {

      const mutationOptions = getDeleteResourcesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Sign in and get token
 */
export const signIn = (
    signInBody: SignInBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SignIn201>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/sessions`,
      signInBody,options
    );
  }



export const getSignInMutationOptions = <TError = AxiosError<SignIn422>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SignInBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SignInBody}, TContext> => {

const mutationKey = ['signIn'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signIn>>, {data: SignInBody}> = (props) => {
          const {data} = props ?? {};

          return  signIn(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignInMutationResult = NonNullable<Awaited<ReturnType<typeof signIn>>>
    export type SignInMutationBody = SignInBody
    export type SignInMutationError = AxiosError<SignIn422>

    /**
 * @summary Sign in and get token
 */
export const useSignIn = <TError = AxiosError<SignIn422>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SignInBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signIn>>,
        TError,
        {data: SignInBody},
        TContext
      > => {

      const mutationOptions = getSignInMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Sign out
 */
export const signOut = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SignOut200>> => {
    
    
    return axios.default.delete(
      `/api/v1/admin/sessions`,options
    );
  }



export const getSignOutMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext> => {

const mutationKey = ['signOut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signOut>>, void> = () => {
          

          return  signOut(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignOutMutationResult = NonNullable<Awaited<ReturnType<typeof signOut>>>
    
    export type SignOutMutationError = AxiosError<unknown>

    /**
 * @summary Sign out
 */
export const useSignOut = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signOut>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSignOutMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Create subscription checkout session url
 */
export const createSubscriptionUrl = (
    createSubscriptionUrlBody: CreateSubscriptionUrlBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateSubscriptionUrl201>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/subscriptions`,
      createSubscriptionUrlBody,options
    );
  }



export const getCreateSubscriptionUrlMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionUrl>>, TError,{data: CreateSubscriptionUrlBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionUrl>>, TError,{data: CreateSubscriptionUrlBody}, TContext> => {

const mutationKey = ['createSubscriptionUrl'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubscriptionUrl>>, {data: CreateSubscriptionUrlBody}> = (props) => {
          const {data} = props ?? {};

          return  createSubscriptionUrl(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSubscriptionUrlMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscriptionUrl>>>
    export type CreateSubscriptionUrlMutationBody = CreateSubscriptionUrlBody
    export type CreateSubscriptionUrlMutationError = AxiosError<unknown>

    /**
 * @summary Create subscription checkout session url
 */
export const useCreateSubscriptionUrl = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionUrl>>, TError,{data: CreateSubscriptionUrlBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSubscriptionUrl>>,
        TError,
        {data: CreateSubscriptionUrlBody},
        TContext
      > => {

      const mutationOptions = getCreateSubscriptionUrlMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Sign up
 */
export const signUp = (
    signUpBody: SignUpBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SignUp201>> => {
    
    
    return axios.default.post(
      `/api/v1/admin/users`,
      signUpBody,options
    );
  }



export const getSignUpMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signUp>>, TError,{data: SignUpBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof signUp>>, TError,{data: SignUpBody}, TContext> => {

const mutationKey = ['signUp'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signUp>>, {data: SignUpBody}> = (props) => {
          const {data} = props ?? {};

          return  signUp(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignUpMutationResult = NonNullable<Awaited<ReturnType<typeof signUp>>>
    export type SignUpMutationBody = SignUpBody
    export type SignUpMutationError = AxiosError<unknown>

    /**
 * @summary Sign up
 */
export const useSignUp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signUp>>, TError,{data: SignUpBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signUp>>,
        TError,
        {data: SignUpBody},
        TContext
      > => {

      const mutationOptions = getSignUpMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
